module.exports = __webpack_public_path__ + "img/sno.61da3e32.jpg";